import React, { useState, useEffect, useContext, useRef, memo } from "react";
import { Grid, Typography } from "@material-ui/core";
import {
  Form,
  Button,
  Row,
  Col,
  Card,
} from "react-bootstrap";
import { ExitToApp, Timeline } from "@mui/icons-material";
import CheckboxDropdown from "../positionPage/position-comp/dropdownWithCheckbox";
import { fmt, fmtINR } from "../../../util/helper";
import {
  GetBrokerActionPnl,
  UpdateBrokerActionPnl,
} from "../../../redux/actions/brokerAction";
import { useDispatch, useSelector } from "react-redux";
import SLTPModal from "../positionPage/position-comp/SLTPModal";
import EditIcon from "@material-ui/icons/Edit";
import editicon from '../../../assets/icons/edit.svg';
import deleteicon from '../../../assets/icons/cancel.svg';
import { Radio, InputNumber, Switch, Input, Tooltip } from "antd";
import FilterModal from "../../common/FilterModal";
import SettingsIcon from '@mui/icons-material/Settings';
import PnlMtmModal from "../../common/PnlMtmModal";
import BrokerService from "../../../services/broker.service";
import { Bolt, SlidersHorizontal } from "lucide-react";


const initial = {
  sltpType: "PNL",
  stopLossAbsolute: null,
  takeProfitAbsolute: null,
  trailReferenceAbsolute: null,
  trailStepAbsolute: null,
  profitLockAtPnl: null,
  profitLockSlPnl: null,
  profitLockTrailRefPnl: null,
  profitLockTrailStepPnl: null,
  slValueType: 0,
  tpValueType: 0,
  trailValueType: 2,
};
const PositionsAction = ({
  exitOrders,
  info,
  columns,
  setColumns,
  totalPNL,
  type,
  sltp,
  isClosedPosition,
  setisClosedPosition,
  exitCE,
  exitPE,
  exitALL,
  width,
  searchText,
  setSearchText,
  checkedId,
  exitSelectedPositions
}) => {
  const dispatch = useDispatch();
  const brokerSLTP = useSelector((state) => state?.orders?.brokerSLTP);
  const positionMarge = useSelector((state) => state?.orders?.positionMarge);
  const valuRef = useRef();
  const [formData, setFormData] = useState(initial);
  const [isModify, setisModify] = useState(false);
  const [isError, seterror] = useState("");
  const [isEditSLTP, seteditSLTP] = useState(false);
  const [popUpData, setpopUpData] = useState({});
  const [isFilter, setisFilter] = useState(false);

  const hasPositions = React.useMemo(() => {
    const allPositions = (positionMarge || []).flatMap((g) => g?.data || []);
    const openPositions = allPositions.filter((p) => p.netQuantity !== 0);

    const ce = openPositions.some((p) => {
      const type = p.instrument?.instrumentType || "";
      if (type === "CE") return true;
    });
    const pe = openPositions.some((p) => {
      const type = p.instrument?.instrumentType || "";
      if (type === "PE") return true;
    });

    const any = openPositions.length > 0;
    const selected = openPositions.some(p => checkedId?.includes(p.id));

    return { ce, pe, any, selected };
  }, [positionMarge, checkedId]);


  useEffect(() => {
    if (brokerSLTP && Object.keys(brokerSLTP).length > 0) {
      const value = {
        ...formData,
        sltpType: "PNL",
        stopLossAbsolute: brokerSLTP.rms?.stopLossInput?.value || null,
        takeProfitAbsolute: brokerSLTP.rms?.takeProfitInput?.value || null,
        trailReferenceAbsolute: brokerSLTP.rms?.trailSL?.reference || null,
        trailStepAbsolute: brokerSLTP.rms?.trailSL?.step || null,
        profitLockAtPnl: brokerSLTP.rms?.profitLockAt || null,
        profitLockSlPnl: brokerSLTP.rms?.profitLockSl || null,
        profitLockTrailRefPnl: brokerSLTP.rms?.profitLockTrail?.reference || null,
        profitLockTrailStepPnl: brokerSLTP.rms?.profitLockTrail?.step || null,
        slValueType: brokerSLTP.rms?.stopLossInput?.valueType || 0,
        tpValueType: brokerSLTP.rms?.takeProfitInput?.valueType || 0,
        trailValueType: brokerSLTP.rms?.trailSL?.valueType || 2,
      };

      setFormData(value);
    }

  }, [brokerSLTP]);

  const clearSLTP = async (params) => {
    const payload = {
      rms: {
        basis: 0,
        takeProfitInput: null,
        stopLossInput: null,
        trailSL: null,
        profitLockAt: null,
        profitLockSl: null,
        profitLockTrail: null
      }
    };
    await dispatch(UpdateBrokerActionPnl(info?.broker?.id, payload));
  };

  const editSLTP = (totalPNL) => {
    seteditSLTP(true);
    setpopUpData({
      row: {},
      headersValue: totalPNL,
      formData: formData,
    });
  };


  const filterHandle = () => {

  }
  return (
    <div
      id="mtm-price"
      style={{ padding: "0px !important", maxWidth: width }}
      className="d-flex   justify-content-between px-2 mb-2 order-window-body align-items-center"
    >
      <div className="d-flex   justify-content-start">
        <div className="pnl-div">
          <p>
            Total PNL:
            <span
              className={`ms-1 ${totalPNL.totalPNL === 0 ? "" : totalPNL.totalPNL > 0 ? "text-success" : "text-danger"}`}
            >
              <b
                id={"total-pnl"}
                style={{
                  fontVariantNumeric: "tabular-nums",
                  fontFeatureSettings: '"tnum"',
                  display: "inline-block",
                  minWidth: "14ch",
                  textAlign: "right",
                }}
              >
                {totalPNL?.totalPNL ? fmtINR(totalPNL?.totalPNL) : 0}
              </b>
            </span>
          </p>
          <p>
            Unrealized:
            <span
              style={{ marginLeft: "4px" }}
              className={`ms-1 ${totalPNL.unrealizedPNL === 0 ? "" : totalPNL.unrealizedPNL > 0 ? "text-success" : "text-danger"}`}
            >
              <b
                id={"total-unrealized"}
                style={{
                  fontVariantNumeric: "tabular-nums",
                  fontFeatureSettings: '"tnum"',
                  display: "inline-block",
                  minWidth: "14ch",
                  textAlign: "right",
                }}
              >
                {totalPNL?.unrealizedPNL ? fmtINR(totalPNL?.unrealizedPNL) : 0.0}
              </b>
            </span>
          </p>
          <p>
            Realized:
            <span
              style={{ marginRight: "18px" }}
              className={
                `ms-1 ${totalPNL.realizedPNL === 0 ? "" : totalPNL.realizedPNL > 0 ? "text-success" : "text-danger"}`
              }
            >
              <b
                id={"total-realized"}
                style={{
                  fontVariantNumeric: "tabular-nums",
                  fontFeatureSettings: '"tnum"',
                  display: "inline-block",
                  minWidth: "14ch",
                  textAlign: "right",
                }}
              >
                {totalPNL?.realizedPNL ? fmtINR(totalPNL?.realizedPNL) : 0.0}
              </b>
            </span>
          </p>
        </div>
        {type === "1" && (
          <div className={isModify ? "d-flex brokersltp topSltp" : "d-flex brokersltp topSltp"}>
            <div align="left" className="pnl-section-items">
              <span>
                Stoploss: <span className="me-1 ms-1">{formData.stopLossAbsolute === 0 ? 0 : fmtINR(formData.stopLossAbsolute)} </span>
              </span>
            </div>
            <div align="left" className="pnl-section-items">
              <span>
                Target: <span className="me-1 ms-1">{formData.takeProfitAbsolute === 0 ? 0 : fmtINR(formData.takeProfitAbsolute)} </span>
              </span>
            </div>
            <div align="left" className="pnl-section-items">
              <span>
                Trailing SL:
                <span className="me-1 ms-1">
                  {formData.trailReferenceAbsolute && formData.trailStepAbsolute ? `${fmtINR(formData.trailReferenceAbsolute)} / ${fmtINR(formData.trailStepAbsolute)}` : "-"}
                </span>
              </span>
            </div>
            <div align="left" className="pnl-section-items">
              <span>
                Profit Lock: <span className="me-1 ms-1">{formData.profitLockAtPnl && formData.profitLockSlPnl ? `${fmtINR(formData.profitLockAtPnl)} / ${fmtINR(formData.profitLockSlPnl)}` : "-"} </span>
              </span>
            </div>
            <div align="left" className="pnl-section-items">
              <span>Profit Trailing: <span className="me-1 ms-1">{formData.profitLockTrailRefPnl && formData.profitLockTrailStepPnl ? `${fmtINR(formData.profitLockTrailRefPnl)} / ${fmtINR(formData.profitLockTrailStepPnl)}` : "-"} </span></span>
            </div>
            <Grid item className="cursor-pointer gap-1 align-items-center me-1 d-flex">
              <Tooltip
                placement="top"
                title={"Edit A/c level Risk Settings"}
                overlayStyle={{ position: 'fixed' }}
              >
                <Bolt
                  size={20}
                  strokeWidth={1.5}
                  alt="edit"
                  onClick={() => editSLTP(totalPNL)}
                  className="risk-settings"
                />
              </Tooltip>
              <Tooltip
                placement="top"
                title={"Clear"}
                overlayStyle={{ position: 'fixed' }}
              >
                {/* <HighlightOffIcon
                  className="cursor-pointer"
                  onClick={() => clearSLTP("clear")}
                /> */}
                <img
                  src={deleteicon}
                  alt="delete"
                  onClick={() => clearSLTP("clear")}
                />
              </Tooltip>


            </Grid>
          </div>
        )}
        <div style={{ width: checkedId && checkedId.length > 0 ? "242px" : "174px" }} className="d-flex btn-exit ms-2">
          <Button disabled={!hasPositions.ce} onClick={() => exitCE()} className=" text-primary" size={"sm"} variant="outline-primary" type="button">Exit CE</Button>
          <Button disabled={!hasPositions.pe} onClick={() => exitPE()} className=" text-warning" size={"sm"} variant="outline-warning" type="button">Exit PE</Button>
          <Button disabled={!hasPositions.any} onClick={() => exitALL()} className="text-danger" size={"sm"} variant="outline-danger" type="button">Exit All</Button>
          {checkedId && checkedId.length > 0 &&
            <Button disabled={!hasPositions.selected} style={{ width: "80px" }} onClick={() => exitSelectedPositions()} className="text-danger" size={"sm"} variant="outline-danger" type="button">Exit Selected</Button>
          }
        </div>

        <div className="d-flex align-items-center ms-3">
          <div className="d-flex align-items-center" style={{ gap: "6px" }}>
            <Input
              size="small"
              placeholder="Search Positions"
              value={searchText}
              allowClear
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 200, height: "25px", fontSize: "12px" }}
            />
          </div>
        </div>

      </div>

      {/* <Grid item className="text-center  me-2 mt-2">
        <div className=" d-flex justify-content-center align-items-center mb-2" style={{padding:"2px", margin:"auto"}}>
           <Grid item className="text-center me-1 ms-1">
            <Typography style={{ fontSize:"11px", marginTop:"3px"}}>Hide Closed Position </Typography>
          </Grid>  
         
          </div> 
      </Grid>   */}

      {type === "1" && (
        <Grid style={{ marginLeft: "20px" }} item className="d-flex justify-content-center align-items-center " >

          <div className="group-sq">
            <Tooltip
              placement="top"
              title={"Hide Closed Position"}
              overlayStyle={{ position: 'fixed' }}
            >
              {/* <HighlightOffIcon
                  className="cursor-pointer"
                  onClick={() => clearSLTP("clear")}
                /> */}
              <Grid item className="text-center">
                <Switch
                  checked={isClosedPosition}
                  onChange={(e) => setisClosedPosition(e)}
                  size="small"
                />
              </Grid>
            </Tooltip>
          </div>
          <Tooltip
            title={"Strategy and position columns configuration"}
            placement="top"
            overlayStyle={{ position: 'fixed' }}
          >
            <SlidersHorizontal className="col-settings" size={20} strokeWidth={1.5} onClick={() => setisFilter(true)} />
          </Tooltip>
        </Grid>
      )}



      {isEditSLTP && (
        <SLTPModal
          show={isEditSLTP}
          setShow={(isFalse) => seteditSLTP(isFalse)}
          popUpData={popUpData}
          istype="broker"
          info={info}
        />
      )}
      <FilterModal
        show={isFilter}
        setShow={(isFalse) => setisFilter(isFalse)}
        columns={columns}
        setColumns={setColumns}
        info={info}
      />
    </div>
  );
};

export default memo(PositionsAction);